import React, { useEffect, useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css"; // Import Bootstrap Icons for the eye icon
import "./CareerDash.css";
import { Link } from "react-router-dom";

const CareerDash = () => {
    const [jobs, setJobs] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [searchCompany, setSearchCompany] = useState("");
    const [searchLocation, setSearchLocation] = useState("");
    const [jobType, setJobType] = useState("all");
    const [currentPage, setCurrentPage] = useState(1);
    const jobsPerPage = 5;
    const userRole = localStorage.getItem("role"); // ✅ Get user role from localStorage

    useEffect(() => {
        fetchJobs();
        const interval = setInterval(fetchJobs, 10000); // Refresh job listings every 10 sec
        return () => clearInterval(interval);
    }, []);

    // const fetchJobs = () => {
    //     fetch("http://localhost:9000/api/jobs/all")
    //         .then((response) => response.json())
    //         .then((data) => setJobs(data.filter((job) => new Date(job.deadline) > new Date()))) // Remove expired jobs
    //         .catch((error) => console.error("Error fetching jobs:", error));
    // };

    // const fetchJobs = async () => {
    //     try {
    //         console.log("📡 Fetching jobs...");
            
    //         // 🔹 Ensure the correct API endpoint is used
    //         const API_BASE_URL = process.env.NODE_ENV === 'production'
    //             ? window.location.origin
    //             : 'http://localhost:9000'; // Change this for backend deployment
            
    //         const response = await fetch(`${API_BASE_URL}/api/jobs/all`, {
    //             method: 'GET',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //             },
    //         });
    
    //         if (!response.ok) {
    //             throw new Error(`Server responded with ${response.status}`);
    //         }
    
    //         const data = await response.json();
    //         console.log("✅ Jobs Fetched Successfully:", data);
    //     } catch (error) {
    //         console.error("❌ Error fetching jobs:", error.message);
    //     }
    // };
    
    const fetchJobs = async () => {
        try {
            const response = await fetch("https://career-service-hd0s.onrender.com/api/jobs/all", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include", // Important for cross-origin requests with cookies
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.json();
            console.log("📜 Jobs fetched:", data); // ✅ Debug API response
    
            setJobs(data.filter((job) => new Date(job.deadline) > new Date())); // Remove expired jobs
        } catch (error) {
            console.error("❌ Error fetching jobs:", error);
        }
    };
    
    const filteredJobs = jobs.filter(
        (job) =>
            job.jobTitle.toLowerCase().includes(searchTitle.toLowerCase()) &&
            job.companyName.toLowerCase().includes(searchCompany.toLowerCase()) &&
            job.location.toLowerCase().includes(searchLocation.toLowerCase()) &&
            (jobType === "all" || jobType === job.jobType)
    );

    const indexOfLastJob = currentPage * jobsPerPage;
    const indexOfFirstJob = indexOfLastJob - jobsPerPage;
    const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleViewJob = async (jobId, applicationLink) => {
        try {
            await fetch(`https://career-service-hd0s.onrender.com/api/jobs/${jobId}/increment-click`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
            });
            window.open(applicationLink, "_blank");
        } catch (error) {
            console.error("Error updating click count:", error);
        }
    };

    const formatCreatedAt = (createdAt) => {
        const date = new Date(createdAt);
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    return (
        <div className="career-dashboard">
            <div className="filters-sidebar">
                <input
                    type="text"
                    placeholder="Search by Title"
                    value={searchTitle}
                    onChange={(e) => setSearchTitle(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Search by Company"
                    value={searchCompany}
                    onChange={(e) => setSearchCompany(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Search by Location"
                    value={searchLocation}
                    onChange={(e) => setSearchLocation(e.target.value)}
                />
                {/* <fieldset className="radio-group">
                    <legend>Filter by Type</legend>
                    <label>
                        <input
                            type="radio"
                            value="all"
                            checked={jobType === "all"}
                            onChange={() => setJobType("all")}
                        />
                        All Opportunities
                    </label>
                    <label>
                        <input
                            type="radio"
                            value="jobs"
                            checked={jobType === "jobs"}
                            onChange={() => setJobType("jobs")}
                        />
                        Jobs
                    </label>
                    <label>
                        <input
                            type="radio"
                            value="internships"
                            checked={jobType === "internships"}
                            onChange={() => setJobType("internships")}
                        />
                        Internships
                    </label>
                </fieldset> */}
                <button onClick={() => setCurrentPage(1)}>Search</button>
            </div>

            <div className="job-listings">
                {/* ✅ Show button only if user role is 'alumni' */}
                {userRole === "alumni" && (
                    <button className="add-job-btn">
                        <Link to="/pages/career-db" style={{ textDecoration: 'none', color: 'white' }}>
                            + Add Job Post
                        </Link>
                    </button>
                )}

                <h2>{filteredJobs.length} Opportunities found</h2>
                {currentJobs.map((job) => (
                    <div key={job._id} className="job-card">
                        <div className="header-row">
                            <h2>
                                {job.jobTitle}
                                <h3>&nbsp; &nbsp; &nbsp;| &nbsp;{job.companyName}</h3>
                            </h2>
                        </div>

                        <div className="info-row">
                            <div className="info-column">
                                <strong>Location</strong>
                                {job.location}
                            </div>
                            <div className="info-column">
                                <strong>Deadline</strong>
                                {new Date(job.deadline).toLocaleDateString()}
                            </div>
                            <div className="info-column">
                                <strong>Salary</strong>
                                {job.salary}
                            </div>
                        </div>

                        <div className="footer">
                            <div className="posted-at">
                                Job posted at {formatCreatedAt(job.createdAt)}
                            </div>

                            {/* <div className="views">
                                <i className="bi bi-eye"></i>&nbsp; {job.clickCount || 0}
                            </div> */}

                            <a
                                href={job.applicationLink.startsWith("http") ? job.applicationLink : `https://${job.applicationLink}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="view-post-btn"
                                onClick={(e) => handleViewJob(e, job._id)}
                            >
                                View Job Post
                            </a>
                        </div>
                    </div>
                ))}

                <div className="pagination">
                    {Array.from(
                        { length: Math.ceil(filteredJobs.length / jobsPerPage) },
                        (_, i) => (
                            <button
                                key={i + 1}
                                onClick={() => paginate(i + 1)}
                                className={currentPage === i + 1 ? "active" : ""}
                            >
                                {i + 1}
                            </button>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default CareerDash;
